<template>
  <div>
    <academic-modal
      ref="academicform"
      id="academic-form"
      :title="titleForm"
      :isLoading="isLoadingGrid"
      :academics="academics"
      :academic="academic"
      @on-create="handleCreate"
      @on-update="handleUpdate"
    />
    <bita-breadcrumb :items="breadCrumbs" />
    

    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            type="primary"
            title="مدرک جدید"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="createDegress"
          />
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import academicDegreesApi from '../../../api/clinic/academicDegreesApi';
import AcademicModal from './components/AcademicModal';

export default {
  components: { AcademicModal },
  data() {
    return {
      pageSize: 10,
      titleForm:"",
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدارک",
          link: "/clinic/academic",
          active: true,
        },
      ],
      academics :[],
      academic :{},
      isLoadingGrid: false,
    };
  },

  mounted() {
  },

  computed: {
    gridColumns() {
      return [
        {
          field: "avatar",
          title: "عکس",
          template: this.getImage,
          width: "100px",
        },
        {
          field: "name",
          title: "عنوان ",
          template: ({ name }) => (name ? name : " - "),
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
        },
      ];
    },
  },
  methods: {
    getFormData(data) {
      let formData = new FormData();
      for (var key in data) {
        if (data[key] != null) formData.append(key, data[key]);
      }
      return formData;
    },
    getImage(element) {
      return `
      <img width="80" src="${element.avatar}" alt="تصویر"
       class="img rounded-circle circle-border slider-image">
      `;
    },
    toggleModal() {
      this.$toggleModal("#academic-form");
    },
    handleUpdate(data){
      let formData = this.getFormData(data);
      academicDegreesApi.update(data.id,formData)
      .then(res=>{
        this.loadData();
      }).finally(()=>{
        this.toggleModal();
        
      })
    },
    handleCreate(data){
      let formData = this.getFormData(data);
      academicDegreesApi.create(formData)
      .then(res=>{
        this.loadData();
      }).finally(()=>{
        this.toggleModal();
        this.loadData();
      })
    },
    createDegress() {
      this.$refs.academicform.reset();
      this.titleForm ="ایجاد مدرک";
      this.toggleModal();
    },
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      academicDegreesApi
        .get('')
        .then(({ data }) => {
          this.academics =data.data.data;
          e.success(data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });

    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },

    delete(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);

      this.$alert("question", `آیا از حذف ${data.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          academicDegreesApi
            .delete(data.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
              this.loadData();
            });
        }
      });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];

      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },

    edit(e) {
      this.academic = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.academicform.setFormData(this.academic);
      this.titleForm ="آپدیت مدرک";
      this.toggleModal();
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
.badge {
  margin: 2px;
  font-size: 13px !important;
  font-weight: 800;
}
</style>
